/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shifts_AssignGroupsRequest } from '../models/shifts_AssignGroupsRequest';
import type { shifts_BulkPublishRequest } from '../models/shifts_BulkPublishRequest';
import type { shifts_BulkPublishResponse } from '../models/shifts_BulkPublishResponse';
import type { shifts_CheckConflictsRequest } from '../models/shifts_CheckConflictsRequest';
import type { shifts_ConflictResponse } from '../models/shifts_ConflictResponse';
import type { shifts_CopyWeekRequest } from '../models/shifts_CopyWeekRequest';
import type { shifts_CopyWeekResponse } from '../models/shifts_CopyWeekResponse';
import type { shifts_CountByStatusResponse } from '../models/shifts_CountByStatusResponse';
import type { shifts_CoverageRangeResponse } from '../models/shifts_CoverageRangeResponse';
import type { shifts_CreateShiftRequest } from '../models/shifts_CreateShiftRequest';
import type { shifts_CreateShiftResponse } from '../models/shifts_CreateShiftResponse';
import type { shifts_LiveCoverageResponse } from '../models/shifts_LiveCoverageResponse';
import type { shifts_PatternResponse } from '../models/shifts_PatternResponse';
import type { shifts_PublishPreviewResponse } from '../models/shifts_PublishPreviewResponse';
import type { shifts_ShiftListResponse } from '../models/shifts_ShiftListResponse';
import type { shifts_ShiftResponse } from '../models/shifts_ShiftResponse';
import type { shifts_SlotCoverageResponse } from '../models/shifts_SlotCoverageResponse';
import type { shifts_UnderstaffedResponse } from '../models/shifts_UnderstaffedResponse';
import type { shifts_UpdateShiftRequest } from '../models/shifts_UpdateShiftRequest';
import type { shifts_UpdateShiftSeriesRequest } from '../models/shifts_UpdateShiftSeriesRequest';
import type { shifts_UpdateShiftSeriesResponse } from '../models/shifts_UpdateShiftSeriesResponse';
import type { shifts_WriteScopeResponse } from '../models/shifts_WriteScopeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShiftsService {
    /**
     * Download the attendance and care ratio inspection report PDF
     * Per-day peak attendance against staff on shift and the configured staffing requirement for one location. German only. Admin only, rate limited per organisation.
     * @param childcareId Childcare (location) ID
     * @param from First day YYYY-MM-DD
     * @param to Last day YYYY-MM-DD (at most 92 days including from)
     * @param lang Language
     * @returns binary PDF file
     * @throws ApiError
     */
    public static getApiV1ChildcaresAttendanceReportPdf(
        childcareId: string,
        from: string,
        to: string,
        lang: 'de' = 'de',
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/childcares/{childcareId}/attendance-report/pdf',
            path: {
                'childcareId': childcareId,
            },
            query: {
                'from': from,
                'to': to,
                'lang': lang,
            },
            errors: {
                400: `Missing, unparseable, inverted or too long date range`,
                401: `Authentication required`,
                403: `Organization ID not found in token or attendance-activities module required`,
                404: `Childcare not found`,
                429: `Rate limit exceeded`,
                500: `Failed to generate PDF`,
            },
        });
    }
    /**
     * Download the attendance and care ratio inspection report as XLSX
     * The same report as the PDF, from the same data, as a workbook: sheet "Zusammenfassung" (signature fields, summary counts, days below the requirement, method) and sheet "Tage" (one row per group and day, frozen header row, numeric count cells, dates as date cells). German only. Same gate, validation and per-organisation rate limit as the PDF.
     * @param childcareId Childcare (location) ID
     * @param from First day YYYY-MM-DD
     * @param to Last day YYYY-MM-DD (at most 92 days including from)
     * @param lang Language
     * @returns binary XLSX file
     * @throws ApiError
     */
    public static getApiV1ChildcaresAttendanceReportXlsx(
        childcareId: string,
        from: string,
        to: string,
        lang: 'de' = 'de',
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/childcares/{childcareId}/attendance-report/xlsx',
            path: {
                'childcareId': childcareId,
            },
            query: {
                'from': from,
                'to': to,
                'lang': lang,
            },
            errors: {
                400: `Missing, unparseable, inverted or too long date range`,
                401: `Authentication required`,
                403: `Organization ID not found in token or attendance-activities module required`,
                404: `Childcare not found`,
                429: `Rate limit exceeded`,
                500: `Failed to generate XLSX`,
            },
        });
    }
    /**
     * List shifts with filters
     * Get paginated list of shifts with optional filters. A caller without shifts-absences (and not admin) never receives DRAFT shifts; status=DRAFT then returns an empty page.
     * @param limit Items per page
     * @param offset Offset for pagination
     * @param employeeId Filter by employee ID. For non-admin callers the filter is narrowed to the caller's visible set (employees sharing a group with the caller, plus themselves); an employee_id outside that set returns an empty page, not an error.
     * @param groupId Filter by group ID. Ignored for a non-admin caller that passes no employee_id: caller scoping narrows the result to the caller's visible employee set instead.
     * @param fromDate Filter from date (YYYY-MM-DD)
     * @param toDate Filter to date (YYYY-MM-DD)
     * @param status Filter by status. DRAFT matches nothing for a caller without shifts-absences (and not admin).
     * @returns shifts_ShiftListResponse OK
     * @throws ApiError
     */
    public static getApiV1Shifts(
        limit: number = 20,
        offset?: number,
        employeeId?: string,
        groupId?: string,
        fromDate?: string,
        toDate?: string,
        status?: 'DRAFT' | 'PUBLISHED' | 'CONFIRMED' | 'CANCELLED',
    ): CancelablePromise<shifts_ShiftListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shifts',
            query: {
                'limit': limit,
                'offset': offset,
                'employee_id': employeeId,
                'group_id': groupId,
                'from_date': fromDate,
                'to_date': toDate,
                'status': status,
            },
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or caller could not be resolved to an employee`,
                500: `Failed to list shifts`,
            },
        });
    }
    /**
     * Create a new shift
     * Create a new employee shift with optional group assignments
     * @param request Shift to create
     * @returns shifts_CreateShiftResponse The created shift (the first of a series), the created count and the days skip_conflicts left out
     * @throws ApiError
     */
    public static postApiV1Shifts(
        request: shifts_CreateShiftRequest,
    ): CancelablePromise<shifts_CreateShiftResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/shifts',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a group lead writes outside the groups they lead (code SHIFT_WRITE_OUT_OF_SCOPE, #2043)`,
                404: `Employee or group not found`,
                409: `A day of the shift or series collides: code SHIFT_CONFLICT (another shift of the employee) or EMPLOYEE_ABSENT (approved absence), with conflict_date and conflict_dates (#2119)`,
                500: `Failed to create shift`,
            },
        });
    }
    /**
     * Delete shift
     * Soft delete a shift and its group assignments
     * @param id Shift ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Shifts(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/shifts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing shift ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a group lead writes outside the groups they lead (code SHIFT_WRITE_OUT_OF_SCOPE, #2043)`,
                404: `Shift not found`,
                500: `Failed to delete shift`,
            },
        });
    }
    /**
     * Get shift by ID
     * Get a single shift by ID with employee and group details
     * @param id Shift ID
     * @returns shifts_ShiftResponse OK
     * @throws ApiError
     */
    public static getApiV1Shifts1(
        id: string,
    ): CancelablePromise<shifts_ShiftResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shifts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing shift ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Shift not found`,
                500: `Failed to get shift`,
            },
        });
    }
    /**
     * Update shift
     * Update an existing shift with optimistic locking
     * @param id Shift ID
     * @param request Updated shift data
     * @returns shifts_ShiftResponse OK
     * @throws ApiError
     */
    public static putApiV1Shifts(
        id: string,
        request: shifts_UpdateShiftRequest,
    ): CancelablePromise<shifts_ShiftResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/shifts/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a group lead writes outside the groups they lead (code SHIFT_WRITE_OUT_OF_SCOPE, #2043)`,
                404: `Shift, employee, or group not found`,
                409: `Shift was modified by another user (code OPTIMISTIC_LOCK), conflicts with existing shift (code SHIFT_CONFLICT) or falls on an approved absence (code EMPLOYEE_ABSENT)`,
                500: `Failed to update shift`,
            },
        });
    }
    /**
     * Assign groups to shift
     * Replace all group assignments for a shift
     * @param id Shift ID
     * @param request Groups to assign
     * @returns void
     * @throws ApiError
     */
    public static putApiV1ShiftsGroups(
        id: string,
        request: shifts_AssignGroupsRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/shifts/{id}/groups',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a group lead writes outside the groups they lead (code SHIFT_WRITE_OUT_OF_SCOPE, #2043)`,
                404: `Shift or group not found`,
                500: `Failed to assign groups`,
            },
        });
    }
    /**
     * Bulk publish shifts
     * Transition all DRAFT shifts in a date range to PUBLISHED status
     * @param request Bulk publish parameters
     * @returns shifts_BulkPublishResponse OK
     * @throws ApiError
     */
    public static postApiV1ShiftsBulkPublish(
        request: shifts_BulkPublishRequest,
    ): CancelablePromise<shifts_BulkPublishResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/shifts/bulk-publish',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a group lead writes outside the groups they lead (code SHIFT_WRITE_OUT_OF_SCOPE, #2043)`,
                500: `Failed to bulk publish shifts`,
            },
        });
    }
    /**
     * Bulk unpublish shifts
     * Transition all PUBLISHED shifts in a date range back to DRAFT status
     * @param request Bulk unpublish parameters
     * @returns shifts_BulkPublishResponse OK
     * @throws ApiError
     */
    public static postApiV1ShiftsBulkUnpublish(
        request: shifts_BulkPublishRequest,
    ): CancelablePromise<shifts_BulkPublishResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/shifts/bulk-unpublish',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a group lead writes outside the groups they lead (code SHIFT_WRITE_OUT_OF_SCOPE, #2043)`,
                500: `Failed to bulk unpublish shifts`,
            },
        });
    }
    /**
     * Check for shift conflicts
     * Check if a proposed shift conflicts with existing shifts for the same employee. With recurrence_type and repetitions (#2119) every day of the proposed series is checked like the save does and conflict_dates/absent_dates list the colliding days. With open_shift (#2040) there is no employee: no overlap, no availability entry, and the warnings count the shift alone. The availability entry (#2041) warns when the shift clashes with the employee's stated availability. The warnings list (#2042) holds DAY_TOO_LONG, WEEK_TOO_LONG and REST_TOO_SHORT against the organisation's shift settings, counting the employee's DRAFT, PUBLISHED and CONFIRMED shifts. Neither ever blocks a save.
     * @param request Conflict check parameters
     * @returns shifts_ConflictResponse OK
     * @throws ApiError
     */
    public static postApiV1ShiftsCheckConflicts(
        request: shifts_CheckConflictsRequest,
    ): CancelablePromise<shifts_ConflictResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/shifts/check-conflicts',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to check conflicts`,
            },
        });
    }
    /**
     * Copy shifts from one week to target weeks
     * Copy all shifts from a source week to one or more target weeks, with optional employee/group filters and conflict handling
     * @param request Copy week parameters
     * @returns shifts_CopyWeekResponse OK
     * @throws ApiError
     */
    public static postApiV1ShiftsCopyWeek(
        request: shifts_CopyWeekRequest,
    ): CancelablePromise<shifts_CopyWeekResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/shifts/copy-week',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a group lead writes outside the groups they lead (code SHIFT_WRITE_OUT_OF_SCOPE, #2043)`,
                500: `Failed to copy week`,
            },
        });
    }
    /**
     * Count shifts by status in a date range
     * Count the number of shifts with a specific status within a date range
     * @param fromDate Start date (YYYY-MM-DD)
     * @param toDate End date (YYYY-MM-DD)
     * @param status Status to count
     * @returns shifts_CountByStatusResponse OK
     * @throws ApiError
     */
    public static getApiV1ShiftsCountByStatus(
        fromDate: string,
        toDate: string,
        status: 'DRAFT' | 'PUBLISHED' | 'CONFIRMED' | 'CANCELLED',
    ): CancelablePromise<shifts_CountByStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shifts/count-by-status',
            query: {
                'from_date': fromDate,
                'to_date': toDate,
                'status': status,
            },
            errors: {
                400: `Missing or invalid parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to count shifts`,
            },
        });
    }
    /**
     * Get shift coverage for a date or date range
     * Returns staff coverage analysis for all groups. Uses a unified response format.
     *
     * **Query options (mutually exclusive):**
     * - `date`: Single date - returns from_date=to_date with one day entry containing group-level details
     * - `from_date` + `to_date`: Date range - returns summary counts per day (groups omitted for performance)
     * - No parameters: Defaults to today's date (in organization's timezone)
     *
     * **Validation rules:**
     * - `date` and `from_date`/`to_date` are mutually exclusive - providing both returns 400
     * - For range queries, both `from_date` AND `to_date` must be provided - providing only one returns 400
     *
     * **Response structure:**
     * - `from_date`, `to_date`: The date range (equal for single-date queries)
     * - `days[]`: Array with one entry per day
     * - `days[].groups`: Group details (only included for single-date queries)
     *
     * **Status values:** SUFFICIENT (>=100%), WARNING (<100% but above critical threshold), CRITICAL (below critical threshold), NO_CHILDREN, NOT_CONFIGURED. Thresholds are derived from the organization's CapacityThresholds settings (default critical ~83% from 120% utilization threshold).
     * @param date Single date (YYYY-MM-DD format) - mutually exclusive with from_date/to_date
     * @param fromDate Start date for range (YYYY-MM-DD format) - requires to_date, mutually exclusive with date
     * @param toDate End date for range (YYYY-MM-DD format) - requires from_date, mutually exclusive with date
     * @returns shifts_CoverageRangeResponse Coverage data with days array
     * @throws ApiError
     */
    public static getApiV1ShiftsCoverage(
        date?: string,
        fromDate?: string,
        toDate?: string,
    ): CancelablePromise<shifts_CoverageRangeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shifts/coverage',
            query: {
                'date': date,
                'from_date': fromDate,
                'to_date': toDate,
            },
            errors: {
                400: `Invalid parameters: mutually exclusive params, missing range bound, invalid date format, or from_date > to_date`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to calculate coverage`,
            },
        });
    }
    /**
     * Get live staff-to-child coverage
     * Returns the LIVE staff-to-child ratio per group for the current moment:
     * children whose derived check-in state is currently checked in, against
     * employees on shift right now -- holding a PUBLISHED or CONFIRMED shift
     * assigned to that group today whose time window covers this instant.
     * Clock-ins are not consulted; the shift plan is the presence signal.
     *
     * This is NOT the same question as GET /api/v1/shifts/coverage, which
     * reports the PLANNED picture (allocated children, scheduled shifts) for a
     * date. Do not substitute one for the other.
     *
     * The route always evaluates now; there is no date parameter. childcare_id is a
     * filter, not a lookup: an unknown or cross-organisation id matches nothing bar the
     * organisation's groups that have no childcare, and always returns status 200.
     * @param childcareId Restrict the returned groups to one childcare (groups with no childcare are always kept)
     * @returns shifts_LiveCoverageResponse Live coverage for the current moment
     * @throws ApiError
     */
    public static getApiV1ShiftsCoverageLive(
        childcareId?: string,
    ): CancelablePromise<shifts_LiveCoverageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shifts/coverage/live',
            query: {
                'childcare_id': childcareId,
            },
            errors: {
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to calculate live coverage`,
            },
        });
    }
    /**
     * Get planned coverage per 15-minute slot
     * Planned staff coverage of every group on one date, in 15-minute slots.
     * Children come from the booked services of each child's allocation, with
     * absences, extra days and same-day group moves applied. Staff come from every
     * non-cancelled shift (DRAFT included) whose window overlaps the slot; breaks are
     * ignored. A group on a closure day (DAYCARE_CLOSURE or PUBLIC_HOLIDAY) returns
     * closed=true and no slots.
     *
     * **Slot status rules, in order:** NOT_CONFIGURED when no staffing model is saved;
     * with no children, NO_CHILDREN (no staff) or SURPLUS (staff); otherwise SURPLUS when
     * scheduled staff exceed required staff, else SUFFICIENT/WARNING/CRITICAL by the
     * coverage percent settings. A qualified-staff shortfall escalates SUFFICIENT and
     * SURPLUS to WARNING. min_staff_per_unit raises required staff only while children
     * are present.
     * @param date Date (YYYY-MM-DD)
     * @returns shifts_SlotCoverageResponse Slot coverage for the date
     * @throws ApiError
     */
    public static getApiV1ShiftsCoverageSlots(
        date: string,
    ): CancelablePromise<shifts_SlotCoverageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shifts/coverage/slots',
            query: {
                'date': date,
            },
            errors: {
                400: `Missing or invalid date`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to calculate slot coverage`,
            },
        });
    }
    /**
     * Get understaffed groups for a date range
     * Returns groups with WARNING or CRITICAL coverage status within the specified date range
     * @param fromDate Start date (YYYY-MM-DD format)
     * @param toDate End date (YYYY-MM-DD format)
     * @returns shifts_UnderstaffedResponse OK
     * @throws ApiError
     */
    public static getApiV1ShiftsCoverageUnderstaffed(
        fromDate: string,
        toDate: string,
    ): CancelablePromise<shifts_UnderstaffedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shifts/coverage/understaffed',
            query: {
                'from_date': fromDate,
                'to_date': toDate,
            },
            errors: {
                400: `Invalid date format or missing parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to get understaffed groups`,
            },
        });
    }
    /**
     * CSV export of the shift plan
     * One row per shift of the inclusive range (at most 92 days), every status: date, employee, start, end, break, net hours, groups, type, status, notes. group_id keeps the shifts of that group; childcare_id keeps the shifts of any group of that childcare; a filtered export leaves out shifts without a group. UTF-8 with BOM, semicolon separator, for Excel de-CH (#2038).
     * @param from First day (YYYY-MM-DD)
     * @param to Last day (YYYY-MM-DD)
     * @param childcareId Childcare filter
     * @param groupId Group filter
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiV1ShiftsExportCsv(
        from: string,
        to: string,
        childcareId?: string,
        groupId?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shifts/export.csv',
            query: {
                'from': from,
                'to': to,
                'childcare_id': childcareId,
                'group_id': groupId,
            },
            errors: {
                400: `Missing or invalid date, to before from, or range over 92 days`,
                401: `Authentication required`,
                403: `No shifts-absences module`,
                500: `Failed to export shifts`,
            },
        });
    }
    /**
     * Publication lead time of a period
     * Returns the days from today (organisation timezone) to from_date, the organisation's publication lead time setting and whether the period is published late (#2042). The planner shows it in the publish dialog as a warning; publishing is never blocked.
     * @param fromDate First day of the period to publish (YYYY-MM-DD)
     * @returns shifts_PublishPreviewResponse OK
     * @throws ApiError
     */
    public static getApiV1ShiftsPublishPreview(
        fromDate: string,
    ): CancelablePromise<shifts_PublishPreviewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shifts/publish-preview',
            query: {
                'from_date': fromDate,
            },
            errors: {
                400: `Missing or invalid from_date`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to compute the publish preview`,
            },
        });
    }
    /**
     * Delete shift series
     * Delete all shifts in a series, optionally only future shifts
     * @param patternId Pattern ID
     * @param futureOnly When true, soft-deletes only shifts from the specified from_date onwards (or today if from_date not provided), retaining the pattern and past shifts for audit/history. When false or omitted (default), soft-deletes all shifts in the series and the associated pattern. All deletions are transactional soft-deletes (sets deleted_at) - no records are permanently removed.
     * @param fromDate When future_only=true, specifies the date from which to delete shifts (format: YYYY-MM-DD). If not provided, uses today's date. This allows deleting shifts from a specific date onwards, e.g., the day after the selected shift.
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ShiftsSeries(
        patternId: string,
        futureOnly?: boolean,
        fromDate?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/shifts/series/{patternId}',
            path: {
                'patternId': patternId,
            },
            query: {
                'future_only': futureOnly,
                'from_date': fromDate,
            },
            errors: {
                400: `Missing patternId parameter or invalid from_date format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a group lead writes outside the groups they lead (code SHIFT_WRITE_OUT_OF_SCOPE, #2043)`,
                404: `Pattern not found`,
                500: `Failed to delete series`,
            },
        });
    }
    /**
     * Get shift pattern details
     * Get a shift pattern with its shift count for series operations
     * @param patternId Pattern ID
     * @returns shifts_PatternResponse OK
     * @throws ApiError
     */
    public static getApiV1ShiftsSeries(
        patternId: string,
    ): CancelablePromise<shifts_PatternResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shifts/series/{patternId}',
            path: {
                'patternId': patternId,
            },
            errors: {
                400: `Missing patternId parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Pattern not found`,
                500: `Failed to get pattern`,
            },
        });
    }
    /**
     * Update shifts in a series
     * Update shifts in a series based on the update scope (this_only, this_and_future, or entire_series)
     * @param patternId Pattern ID
     * @param shiftId Shift ID (the shift being edited)
     * @param request Update data and scope
     * @returns shifts_UpdateShiftSeriesResponse The edited shift (or the first shift of the series when the edit removed it) with what the edit changed
     * @throws ApiError
     */
    public static putApiV1ShiftsSeriesShifts(
        patternId: string,
        shiftId: string,
        request: shifts_UpdateShiftSeriesRequest,
    ): CancelablePromise<shifts_UpdateShiftSeriesResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/shifts/series/{patternId}/shifts/{shiftId}',
            path: {
                'patternId': patternId,
                'shiftId': shiftId,
            },
            body: request,
            errors: {
                400: `Validation errors, missing parameters, or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a group lead writes outside the groups they lead (code SHIFT_WRITE_OUT_OF_SCOPE, #2043)`,
                404: `Pattern, shift, or group not found`,
                409: `Shift was modified by another user (code OPTIMISTIC_LOCK) or conflicts with existing shift (code SHIFT_CONFLICT)`,
                500: `Failed to update series`,
            },
        });
    }
    /**
     * Get the caller's shift write scope
     * Which shifts the caller may create, edit, move, delete, publish and unpublish (issue #2043). Admins and shifts-absences holders who lead no group are unrestricted. A holder who leads groups (groups.lead_employee_id) writes only shifts whose groups are non-empty and all led, for the employees in their visible scope; every other write answers 403 with code SHIFT_WRITE_OUT_OF_SCOPE.
     * @returns shifts_WriteScopeResponse OK
     * @throws ApiError
     */
    public static getApiV1ShiftsWriteScope(): CancelablePromise<shifts_WriteScopeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shifts/write-scope',
            errors: {
                401: `Authentication required`,
                403: `Organization ID not found in token, or caller could not be resolved to an employee`,
            },
        });
    }
}
